module.exports = __webpack_public_path__ + "img/dp-top-bg.d07f037d.png";